<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5">
            <!-- <a @click="openPage('/ptSessionBuy/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a> -->
            <table>
              <tr>
                <td>
                  <a v-if="getRoleId != '33'" @click="openPage('/ptSessionBuy/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
                </td>
                <td>
                  <a @click="exportBuyPtSession()" class="btn-primary mr-5"><i class="far fa-file-alt mr-4"></i>Export</a>
                </td>
                <td>
                  <flat-pickr :config="exportConfig" @on-change="changeDatePtSession" v-model="exportDates" name="export_date_start" class="font-13"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-sm-3">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-sm-4 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <!-- {{items}} -->
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(name)="data">
<!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">
              {{data.item.member.first_name}} {{data.item.member.last_name}}
            </template>
            <!-- <div>{{data.item.member_id}}</div> -->
          </template>
          <template v-slot:cell(gross_amount)="data">
            {{data.item.gross_amount | toRupiah}}
          </template>
          <template v-slot:cell(date)="data">
<!--          <template slot="date" slot-scope="data">-->
            {{parseDate(data.item.created_at)}}
          </template>
          <template v-slot:cell(time)="data">
<!--          <template slot="time" slot-scope="data">-->
            {{parseTime(data.item.created_at)}}
          </template>
          <template v-slot:cell(is_agree)="data">
            <template v-if="data.item.is_agree == 1">
              <b-badge :variant="'success'" >Success</b-badge>
            </template>
            <template v-if="data.item.is_agree == 0">
              <b-badge :variant="'warning'" >Waiting...</b-badge>
            </template>
          </template>
          <template v-slot:cell(actions)="data">
<!--          <template slot="actions" slot-scope="data">-->
            <template v-if="disableBtnEdit">
              <b-button v-if="getRoleId != '33'" size="sm" disabled class="btn-table warning mr-1">
                <i class="far fa-edit"></i> Edit
              </b-button>
            </template>
            <template v-else>
              <b-button v-if="getRoleId != '33'" size="sm" @click="editForm('/ptSessionBuy/edit?id=' + data.item.id)" class="btn-table warning mr-1">
                <i class="far fa-edit"></i> Edit
              </b-button>
            </template>
            <!-- <b-button size="sm" v-on:click="deleteForm(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i> Delete
            </b-button> -->
            <b-button v-if="data.item.ticked_status !== 1" @click="openAgreement(data.item.id)" class="btn-table green">
              <i class="fas fa-file-signature"></i> Agreement
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
      <b-modal modal-class="modal-custom-form" hide-footer v-model="modalShow" centered title="Form Agreement">
        <div class="container-iframe mobile-responsive">
          <iframe v-show="urlDoc" :srcdoc="urlDoc" class="w-100" frameborder="0"></iframe>
          <div class="p-20 bg-white">
            <div class="row justify-content-center">
              <div class="col-md-6">
                <div class="checkbox-part text-center">
                  <form data-vv-scope="submit-form">
                    <input type="checkbox" v-validate="'required'" id="agreeForm" name="checkbox_agree" v-model="checked" value=""><label for="agreeForm" class="font-13 font-300 ml-10 label-agree">Click here to indicate that you have read and agree to the terms presented in the Terms and Conditions agreement</label>
                    <div class="text-center mt-10 mb-5">
                      <span class="error color-red">{{ errors.first('submit-form.checkbox_agree') }}</span>
                    </div>
                  </form>
                </div>
                <div class="d-flex justify-content-center">
                  <button type="submit" @click.prevent="validateTick('submit-form')" class="btn-primary text-center mt-10">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import moment from 'moment'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'ptSessionBuy',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'branch.name',
          label: 'Branch',
          sortable: true
        },
        {
          key: 'personal_training.name',
          label: 'Personal Training',
          sortable: true
        },
        {
          key: 'id',
          label: 'PT Tier',
          sortable: true
        },
        {
          key: 'gross_amount',
          label: 'Price',
          sortable: true
        },
        {
          key: 'is_agree',
          label: 'Agreement',
          sortable: true
        },
        {
          key: 'is_agree_click_date',
          label: 'Agreement Date',
          sortable: false,
          formatter: (value) => {
            if (value) {
              return moment(value).format('DD MMM YYYY hh:mm A')
            } else {
              return '-'
            }
          }
        },
        {
          key: 'transaction_status',
          label: 'Transaction Status',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: true
        }
      ],
      dataGetUrlLead: {
        doc_name: 'personal_trainer.hbs',
        trx_id: ''
      },
      dataAgree: {
        ticked_status: ''
      },
      disableBtnEdit: false,
      items: [],
      dataBranch: [],
      branch_id: null,
      getId: Auth.Session.get().paradigm_id,
      getRoleId: Auth.Session.get().paradigm_role,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      checked: false,
      checked2: false,
      urlDoc: '',
      modalShow: false,
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    changeDatePtSession(selectedDates, dateStr, instance) {
      if(selectedDates.length === 2){
          if(typeof selectedDates[0] === typeof selectedDates[1]){
              this.exportDates = dateStr + ' to ' + dateStr
          }else{
              this.exportDates = dateStr
          }
          if(this.exportDates.includes(" to ") === true) {
              this.fetchData()
          }
      }
    },
    exportBuyPtSession() {
      let dates = this.exportDates.split(' to ')
      let url = 'fitness/v1/export/buy_pt_session_report?'
      + 'sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData
      + '&start_date='+dates[0]
      +'&end_date='+dates[1]

      if (this.branch_id != null) {
        url = url + '&branch_id=' + this.branch_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Buy PT Session History Report '+moment(dates[0]).format('DD MMM YYYY')+' - '+moment(dates[1]).format('DD MMM YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    validateTick (data1) {
      this.$validator.validateAll(data1).then(async result => {
        if(result) {
          if(this.checked === true) {
            this.dataAgree.ticked_status = 1
          } else {
            this.dataAgree.ticked_status = 0
          }
          try{
            const agreeStatus = await axios.put('transaction/v1/transaction/tick_form_agreement/' + this.dataGetUrlLead.trx_id, this.dataAgree)
            // console.log('Success submit tick',agreeStatus.data)
            // this.$router.push('/ptSessionBuy')
            this.modalShow = false
            this.fetchData()
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          } catch(error){
            console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          }
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openAgreement (event) {
      this.dataGetUrlLead.trx_id = event
      axios.post('crm/v1/form_aggreement/html_generate/pt_session', this.dataGetUrlLead).then(response => {
                  // console.log('test', response)
        this.urlDoc = response.data
        this.modalShow = true
      }).catch(error => {
        // console.log('error', error)
        this.$toast.success('Error get data!', 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
      })
    },
    parseDate (value) {
      moment.locale('en')
      return moment(value).format('DD MMMM YYYY')
    },
    parseTime (value) {
      moment.locale('en')
      return moment(value).format('h:mm a')
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editForm (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteForm(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/pt_session_transaction/' + (event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    changeBranch(event) {
      this.branch_id = event
      this.fetchData()
      // let url = 'fitness/v1/pt_session_transaction?page=' + this.currentPage
      // + '&limit=' + this.paginationLimit
      // + '&sorting=' + this.sortBy
      // + '&sorting_type=' + this.sortType
      // + '&keyword=' + this.searchData

      // if (event != null)
      //   url = url + '&branch_id=' + event

      // axios.get(url).then(response => {
      //   this.items = response.data.data.rows
      //   this.totalPage = response.data.meta.pageCount
      // }).catch(error => {
      //   console.log('error', error)
      // })
    },
    fetchData() {
      let dates = this.exportDates.split(' to ')
      let url = 'fitness/v1/pt_session_transaction?page=' + this.currentPage
      + '&limit=' + this.paginationLimit
      + '&sorting=' + this.sortBy
      + '&sorting_type=' + this.sortType
      + '&keyword=' + this.searchData
      + '&start_date='+dates[0]
      +'&end_date='+dates[1]

      if (this.branch_id != null)
        url = url + '&branch_id=' + this.branch_id

      axios.get(url).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })

      //branch
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows

        // for login PT SPV
        const is_pt_spv = Auth.Session.get().paradigm_role_mapping_id
        if (is_pt_spv.includes(22)) {
          this.branch_id = Auth.Session.get().paradigm_branch_id
          const find = this.dataBranch.find((m) => m.id == Auth.Session.get().paradigm_branch_id)
          if (find) {
            this.dataBranch = []
            this.dataBranch.push(find)
          }
        }

      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    const is_pt_spv = Auth.Session.get().paradigm_role_mapping_id
    if (is_pt_spv.includes(22)) {
      this.branch_id = Auth.Session.get().paradigm_branch_id
      this.disableBtnEdit = true
    }
    this.fetchData()
  }
}
</script>

<style>
</style>
